
export const defaultDestinations = [
  { id: 'd1', planet: '', vehicle: '', distance: 0, speed: 0},
  { id: 'd2', planet: '', vehicle: '', distance: 0, speed: 0},
  { id: 'd3', planet: '', vehicle: '', distance: 0, speed: 0},
  { id: 'd4', planet: '', vehicle: '', distance: 0, speed: 0}
];
